import { render, staticRenderFns } from "./DonutWidget.vue?vue&type=template&id=63548bab&scoped=true&"
import script from "./DonutWidget.vue?vue&type=script&lang=js&"
export * from "./DonutWidget.vue?vue&type=script&lang=js&"
import style0 from "./DonutWidget.vue?vue&type=style&index=0&id=63548bab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63548bab",
  null
  
)

export default component.exports